import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled React error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background px-4 text-center">
          <p className="text-lg text-foreground mb-6">
            Ndodhi një gabim. Ju lutemi rifreskoni faqen.
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="px-6 py-2.5 bg-primary text-white rounded-lg font-medium hover:bg-primary-700 transition-colors"
          >
            Rifresko
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
